import React, { useState } from 'react'
import { Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { changeCampaignsModal, requestActiveEmailChannelStatistics, setActiveEmailChannelStatisticsDate } from '../../../../redux/actions/campaigns'
import { sendErrorNotification } from '../../../universal/notifications/notifications'
import LoadingView from './loading-view'
import EmptyView from './empty-view'
import AuthenticateDomainView from './domain-status-view'
import ChannelInsights from './channel-insights'
import UpperRow from './upper-row'
import './style.scss'

const Index = () => {

    const dispatch = useDispatch()

    const activeChannel = useSelector(state => state.campaigns.activeChannel)
    const channelsLoading = useSelector(state => state.campaigns.fetchAllChannels.loading)

    const sourceLoading = useSelector(state => state.campaigns.activeChannel.source?.loading)
    const source = useSelector(state => state.campaigns.activeChannel.source)

    const verificationStatus = useSelector(state => state.campaigns.initializeDomain.verification.status)

    const channels = useSelector(state => state.campaigns.channels)

    const clickNewConfiguration = () => {
        dispatch(changeCampaignsModal({newChannelModal: true}))
    }

    const handleClickVerify = () => {
        dispatch(changeCampaignsModal({verifyDomainModal: true}))
    }

    const handleClickComplete = () => {
        if(!sourceLoading && source?.status?.dns && Object.keys(source?.status?.dns).length > 0){
            dispatch(changeCampaignsModal({completeSetupModal: true}))
        } else {
            sendErrorNotification("Kan ikke hente DNS detaljer.")
        }
    }

    const clickPurchaseNumber = () => {
        dispatch(changeCampaignsModal({purchaseNumberModal: true}))
    }

    const renderView = () => {
        if(channelsLoading || sourceLoading){
            return <LoadingView title="Henter kanaldetaljer.." description="Vennligst vent mens vi henter kanalene dine"/>
        } else {
            if(channels && channels.length === 0){
                return <EmptyView clickNewConfiguration={clickNewConfiguration}/>
            } else {
                if(Object.keys(activeChannel).length > 0){
                    if(activeChannel.type === "email"){
                        if(!channelsLoading && !sourceLoading){
                            if(source.status?.code === "success" || verificationStatus === "success"){
                                return <ChannelInsights/>
                            } else if(source.status?.code === "pending"){
                                return <AuthenticateDomainView title="Fullfør verifiseringen" description="Du mangler fortsatt å verifisere domenet ditt, du kan se verdiene for DNS som trengs nedenfor." buttonTitle="Fullfør nå" onClick={handleClickComplete}/>
                            } else {
                                return <AuthenticateDomainView title="Verifiser eierskap" description="For å kunne starte å sende e-post må du verifisere eierskap til domenet du ønsker å sende fra." buttonTitle="Kom i gang nå" onClick={handleClickVerify}/>
                            }
                        }
                    } else if(activeChannel?.type === "sms") {
                        if(!channelsLoading && !sourceLoading){
                            if(source?.status?.number){
                                return <ChannelInsights/>
                            } else {
                                return <AuthenticateDomainView title="Telefonnummer mangler" description="For å kunne sende ut SMS må du først kjøpe et nummer, og dette kan du enkelt gjøre ved å trykke på knappen nedenfor." buttonTitle="Kjøp et nummer" onClick={clickPurchaseNumber}/>
                            }
                        }
                    } else {
                        return <EmptyView clickNewConfiguration={clickNewConfiguration}/>
                    }
                }
            }
        }
    }

    return(
        <section className="dashboard-campaigns-upper-row-section">
            {!channelsLoading && !sourceLoading && <UpperRow/>}
            {renderView()}
        </section>
    )
}

export default Index

